import Controls from './Controls/Controls';
import SwapDots from './SwapDots/SwapDots';

export default {
    Controls,
    SwapDots,
};
